"use strict";import{tag as e}from"../custom-tag.js";export function podcastMicIcon({height:t=16,width:r=16,hidden:l=!1,title:a="Podcast mic"}={}){return e`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${r}
      height=${t}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${l?"true":"false"}"
      role="img"
      aria-label="${a}"
    >
      <path
        fill="currentColor"
        d="M12 16.186a3.2 3.2 0 0 0 3.225-3.17V5.945a3.225 3.225 0 0 0-6.45 0v7.073A3.2 3.2 0 0 0 12 16.186M9.225 5.944a2.775 2.775 0 0 1 5.541-.169H13.2v.45h1.575v1.35H13.2v.45h1.575v1.35H13.2v.45h1.575v3.192a2.775 2.775 0 0 1-5.55 0z"
      />
      <path
        fill="currentColor"
        d="M16.425 12.91V11.4h-.45v1.51c0 2.351-1.783 4.265-3.975 4.265s-3.975-1.914-3.975-4.266V11.4h-.45v1.51c0 2.52 1.865 4.578 4.2 4.704v3.162h-3v.45h6.45v-.45h-3v-3.162c2.335-.126 4.2-2.184 4.2-4.704"
      />
    </svg>
  `}
//# sourceMappingURL=podcastMic.js.map
